<script>
import formatDate from '@utils/format-date'
import formatServiceTime from '@utils/format-service-time'
import { merchantComputed } from '@store/helpers'
import 'slick-carousel/slick/slick.css'

export default {
  components: {
    Slick: () => import('vue-slick'),
    OrderReservationInfo: () => import('@components/Order/OrderReservationInfo'),
    OrderDetailsBox: () => import('./ReservationItemSectionItemDetailsBox.Jtails'),
    OrderPaymentButton: () => import('@components/Order/OrderPaymentButton'),
  },
  props: {
    containerItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    const DEFAULT_PAGE_COUNT = this.$route.query.order || 1
    return {
      pageCount: DEFAULT_PAGE_COUNT,
      slickOptions: {
        slidesToShow: 1,
        draggable: false,
        slidesToScroll: 1,
        infinite: false,
        fade: true,
        initialSlide: DEFAULT_PAGE_COUNT - 1,
        arrows: true,
        centerPadding: '0px',
        touchThreshold: 6,
        centerMode: false,
        dots: false,
        nextArrow: '<button type="button" class="slick-next"></button>',
        prevArrow: '<button type="button" class="slick-prev"></button>',
      },
      isActiveTab: 'detail',
    }
  },
  computed: {
    ...merchantComputed,
    address() {
      const isStore = this.containerItem.param.store.storeType === 'store'
      const { city, district, address } = this.containerItem

      return isStore ? this.containerItem.param.store.fullAddress : `${city}${district}${address}`
    },
    currentOrderItem() {
      return this.containerItem.orders.items[this.pageCount - 1]
    },
    childrenContainersUnPaid() {
      return this.containerItem?.childrenContainers?.items.find((item) => {
        return item.paymentStatus === 'UNPAID'
      })
    },
    getOrderList() {
      return this.containerItem.orders.items.filter((item) => {
        return item.type === this.type
      })
    },
  },
  mounted() {
    const slideTo = () => {
      if (this.$route.query.activeAlias) {
        const activeAliasIndex = this.containerItem.orders.items.findIndex((item) => item.id === this.$route.query.activeAlias)
        if (activeAliasIndex >= 0)
          // this.$nextTick(() => {
          this.onSlideTo(activeAliasIndex + 1)
        // })
      }
    }
    setTimeout(() => {
      slideTo()
    }, 800)
  },
  methods: {
    formatDate,
    formatServiceTime,
    getDefaultImage(images) {
      const defaultImageItems = images.filter((image) => image.default) || []

      return defaultImageItems[0]?.path || ''
    },
    onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.pageCount = nextSlide + 1
    },
    onSlideTo(index) {
      this.pageCount = index
      this.$refs.slick.goTo(index - 1)
    },
    onNext() {
      this.$refs.slick.next()
    },
    onPrev() {
      this.$refs.slick.prev()
    },
    openDialogPet({ type, petItem = {} }) {
      this.$globalDialog('DialogPet', {
        type: 'edit',
        petItem,
        callbackEditPet: (submitData) => {
          this.$emit('update')
        },
        // callbackNewPet: (submitData) => {
        //   this.$emit('callbackNewPet')
        // },
        // callbackRemovePet: (submitData) => {
        //   this.$emit('callbackRemovePet')
        // }
      })
    },
    openDialogPetEdit(petItem) {
      this.openDialogPet({
        type: 'edit',
        petItem,
      })
    },
    goToGoogleCalendar(orderItem) {
      // dates   時間格式為 YYYYMMDDTHHMMSS
      // details 使用 %0A 作為跳行
      const text = `[${this.currentMerchant.title}${orderItem.param.store.title}] ${orderItem.pet.name} - ${orderItem.param.title}` || ''
      const start = orderItem.startDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T')
      const end = orderItem.endDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T')
      const dates = `${start}/${end}`
      const details = orderItem.param.description || ''
      const location = orderItem.param.store.fullAddress
      const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`

      window.open(`http://www.google.com/calendar/event?${query}`)
    },
    openDialogContact(storeList) {
      this.$globalDialog('DialogContact', {
        storeList,
      })
    },
    onChangeActiveTab(val) {
      this.isActiveTab = val
    },
    showCancelPrepaidDialog(item) {
      this.$emit('showCancelPrepaidDialog', item)
    },
  },
}
</script>
<!-- section template -->
<template>
  <div :class="$style.reservationItemSectionItemInfoBox">
    <div v-if="type !== 'goods'" class="reservationItemSectionItemInfoBox__infoBoxTop">
      <div class="reservationItemSectionItemInfoBox__infoBoxTopInner">
        <span>預約{{ $t('site.USER') }}</span>
        <div class="reservationItemSectionItemInfoBox__petList">
          <ul :class="$style.petList">
            <template v-for="(item, $index) in getOrderList">
              <el-tooltip :key="$index" effect="light" :content="item.pet.name" placement="top">
                <li
                  :key="$index + 1"
                  class="petList__item"
                  :class="{ isActive: $index + 1 === pageCount }"
                  :style="{ backgroundImage: `url('${item.pet.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`)}')` }"
                  @click="onSlideTo($index + 1)"
                ></li>
              </el-tooltip>
            </template>
          </ul>
        </div>
      </div>
      <hr class="my-3" />
    </div>
    <div class="reservationItemSectionItemInfoBox__slickOrderItem">
      <Slick ref="slick" :options="slickOptions" class="slick isStyleBase" :class="$style.carouselList" @beforeChange="onBeforeChange">
        <div v-for="(carouselItem, index) in getOrderList" :key="index">
          <div v-if="type === 'goods'">
            <ul class="reservationItemSectionItemInfoBox__slickGoodList">
              <li v-for="(item, _index) in carouselItem.params" :key="_index">
                <div v-if="item.store" class="isSmall mr-2 el-tag el-tag--light isStyleGray isRadius-0">{{ item.store.title }}</div>
                <img v-if="item.images.length > 0" :src="item.images[0].path" class="goodImg" />
                <div class="goodInfo">
                  {{ item.title }}
                  <div v-if="item.spec" class="isSpec">
                    <div v-for="(sp, i) in item.spec" :key="i" class="baseList__text">
                      {{ sp.title }} : <span v-for="(v, _i) in sp.values" :key="_i">{{ v.title }}<i v-if="_i < sp.values.length - 1">、</i></span
                      ><i v-if="i < item.spec.length - 1"> | </i>
                    </div>
                  </div>
                  <div>x{{ item.qty }}</div>
                </div>
                <div>NT${{ item.price }}</div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="reservationItemSectionItemInfoBox__slickPetList">
              <div class="container--callback ">
                <div class="row">
                  <div class="col-md-4 col-12 text-center">
                    <div
                      class="slickPetList__img"
                      :style="{ backgroundImage: `url('${carouselItem.pet.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`)}')` }"
                    >
                    </div>
                    <div class="text-primary-dark mt-2 mb-3">{{ carouselItem.pet.name }}</div>
                  </div>
                  <div class="col-md-8 col-12 text-md-left text-center">
                    <div class="text-gray-2 fs-sm pt-2 mb-2">
                      {{ carouselItem.pet.gender ? `${carouselItem.pet.gender === 'male' ? $t('site.FORM_GENDER_MALE') : $t('site.FORM_GENDER_FEMALE')}` : '' }}
                      <template v-if="carouselItem.pet.gender && $globalCategoryVisible">
                        |
                      </template>
                      <template v-if="$globalCategoryVisible"
                        >{{ carouselItem.pet.categoryTitle }} | {{ carouselItem.pet.sizeTitle }}</template
                      >
                      {{ carouselItem.pet.breed ? ` | ${carouselItem.pet.breed}` : '' }}
                      <br />
                      {{ formatDate(carouselItem.pet.birthday, 'yyyy/MM/dd') }}
                    </div>
                    <BaseButton
                      class="isSmall"
                      :class="{ 'isStyleSecondary isOutline': $globalIsDingBeauty, 'isRadius isStyleDark isOutline3': $globalIsJtails }"
                      @click="openDialogPetEdit(carouselItem.pet)"
                    >
                      {{ $t('site.USER') }}資料
                    </BaseButton>
                  </div>
                </div>
              </div>
            </div>
            <div class="reservationItemSectionItemInfoBox__slickInfoList">
              <OrderReservationInfo :item="carouselItem" is-detail @showCancelPrepaidDialog="showCancelPrepaidDialog" />
              <div class="reservationItemSectionItemInfoBox__slickInfosite text-center text-gray-2 py-2">
                服務地點：<a class="sitelink" :href="`https://www.google.com.tw/maps/search/${carouselItem.param.store.fullAddress}`" target="_blank"
                  >{{ carouselItem.param.store.fullAddress }}<i class="fal fa-external-link ml-2 fs-2sm"></i
                ></a>
              </div>
            </div>
          </div>

          <div class="reservationItemSectionItemInfoBox__contentBox mt-5">
            <OrderDetailsBox ref="OrderDetailsBox" :container-item="containerItem" :order-item="carouselItem" @changeActiveTab="onChangeActiveTab" />
          </div>
        </div>
      </Slick>
    </div>
    <div v-if="$globalIsDingBeauty" class="dingBeautyButtonFixed isStyleMobileShow">
      <BaseButton :to="{ name: 'member-reservation' }" class="isStyleSecondary isOutline3 isFull mr-3">
        回列表
      </BaseButton>
      <BaseButton class="isStyleSecondary isOutline3 isFull mr-3" @click="goToGoogleCalendar(currentOrderItem)">
        <span>加入行事曆</span>
        <i class="fal fa-external-link ml-2"></i>
      </BaseButton>
      <BaseButton
        class="isStyleSecondary isOutline3 isFull mr-3"
        :to="{ name: 'reservation-item', params: { reservationAlias: currentOrderItem.param.alias, storeAlias: currentOrderItem.param.store.alias } }"
      >
        查看服務資訊
      </BaseButton>
      <BaseButton class="isStyleSecondary isOutline3 isFull mr-3" @click.native="openDialogContact([currentOrderItem.param.store])">
        聯繫我們
      </BaseButton>
      <OrderPaymentButton v-if="isActiveTab === 'detail'" :order-item="containerItem" type="reservation" class="w-100" />
      <OrderPaymentButton v-else :order-item="childrenContainersUnPaid" type="memberOrderReservationChildren" class="w-100 d-md-block d-none" />
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.reservationItemSectionItemInfoBox {
  margin-bottom: 2rem;
  // background: rgba($color-gray-4, 0.2);
  // border-radius: 24px;

  @include max-md {
    padding: 0;
    // border-radius: 12px;
  }

  .sitelink {
    color: $color-gray-2;
    transition: color 0.3s;

    &:hover {
      color: $color-primary;
    }
  }

  :global {
    .reservationItemSectionItemInfoBox {
      &__img {
        padding-top: 74.3%;
        // border-radius: 24px;
        margin: -16px;
        margin-right: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;

        @include max-md {
          padding-top: 40%;
          margin: 0;
          margin-bottom: 1rem;
          // border-radius: 12px;
        }
      }
      &__infoBoxTopInner {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      &__infoBoxTop {
        padding: 1.5rem;
        background: #fafafa;
        hr {
          margin-left: -1.5rem;
          margin-right: -1.5rem;
        }
      }
      &__infoBoxLeft {
        @include unstyled;
      }

      &__infoBoxRight {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        @include max-md {
          padding-right: 35px;
          padding-bottom: 1rem;
          padding-left: 35px;
        }
      }

      &__title {
        margin-bottom: 0.25rem;
        font-size: 1.125rem;

        @extend %FontSerifWeightJtails;

        letter-spacing: 0.281rem;

        @include max-md {
          font-size: 0.875rem;
          color: $color-blue-dark;
        }
      }

      &__meta {
        font-size: 0.875rem;
        color: $color-gray-2;

        @include max-md {
          margin-bottom: 1rem;
          font-size: 0.75rem;
        }
      }

      &__info {
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;

        @include max-xl {
          font-size: 0.75rem;
        }
      }
      &__slickPetList {
        background: #fafafa;
        padding-bottom: 1.875rem;
        .container--callback {
          max-width: 100%;
        }
        .slickPetList {
          &__img {
            flex-shrink: 0;
            width: 80px;
            height: 80px;
            background-color: #e4e7e9;
            background-image: url('~@assets/images/reservation/pet-avatar-default@2x.png');
            background-position: center;
            background-size: cover;
            border: 1px solid #fff;
            border-radius: 100%;
            position: relative;
            margin: 0 auto;
          }
        }
      }
      &__slickGoodList {
        list-style: none;
        padding: 0 19px;
        background-color: #f9f9fc;
        margin: 20px 0;
        li {
          display: flex;
          padding: 24px;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          &:not(:last-child) {
            border-bottom: 1px solid #a3aab1;
          }
          .goodImg {
            width: 116px;
            margin: 0 30px;
          }
          .isSpec {
            display: flex;
            flex-wrap: wrap;
            text-wrap: nowrap;
            margin: 15px 0;
          }
        }
      }
      &__slickInfoList {
        position: relative;
        background: #fafafa;
        padding: 1.875rem 0 0;
        @include max-md {
          padding: 1rem;
        }
        &::before {
          content: '';
          width: 100%;
          height: 1px;
          background-image: linear-gradient(90deg, $color-line, $color-line 75%, transparent 75%, transparent 100%);
          background-size: 10px 1px;
          border: none;
          position: relative;
          top: -1.875rem;
          left: 0;
          right: 0;
          display: block;
        }
      }
      &__slickInfosite {
        background: rgba($color-line, 0.25);
        .sitelink {
          color: $color-gray-2;
          &:hover {
            color: $color-primary;
          }
        }
      }
    }
    .slick-slider {
      -webkit-user-select: text;
      -khtml-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
    }
    .slick-list.draggable {
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    // stylelint-disable selector-class-pattern
    .slick-arrow {
      // height: 100%;
      // width: 100px;
      position: absolute;
      top: 18px;
      // top: 0;
      z-index: 1;
      width: 70px;
      height: 70px;
      font-size: 0;
      color: #fff;
      // background: transparent;
      background: rgba(#000, 25%);
      border: unset;
      opacity: 1;
      transition: opacity 0.3s;
      // transform: translateY(-50%);
      appearance: none;

      @include max-md {
        width: 50px;
        height: 50px;
      }

      &::before {
        font-size: 2.75rem;

        @include max-md {
          font-size: 2rem;
        }
      }

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        content: '';
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:hover:not(:disabled) {
        opacity: 0.6;
      }

      &:active:not(:disabled) {
        opacity: 0.4;
        transition: opacity 0s;
      }
      &.slick-disabled {
        cursor: not-allowed;
        background: rgba($color: $color-line, $alpha: 0.5);
        &:hover {
          background: rgba($color: $color-line, $alpha: 0.5);
          opacity: 1;
        }
        &::after {
          background: transparent !important;
        }
      }

      &.slick-prev {
        left: 0;

        @media (min-width: 1920px) {
          left: calc((100vw - 1920px) / 2);
        }

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-left-helf;
        }

        &::after {
          background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover:not(:disabled) {
          &::after {
            opacity: 0.6;
          }
        }
      }

      &.slick-next {
        right: 0;

        @media (min-width: 1920px) {
          right: calc((100vw - 1920px) / 2);
        }

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-right-helf;
        }

        &::after {
          background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover:not(:disabled) {
          &::after {
            opacity: 0.6;
          }
        }
      }
    }
    // stylelint-enable selector-class-pattern
  }
  .petList {
    @include list-unstyled;
    display: flex;
    :global {
      .petList {
        &__item {
          flex-shrink: 0;
          width: 50px;
          height: 50px;
          background-color: #e4e7e9;
          background-image: url('~@assets/images/reservation/pet-avatar-default@2x.png');
          background-position: center;
          background-size: cover;
          border: 1px solid #fff;
          border-radius: 100%;
          position: relative;
          cursor: pointer;
          transform: scale(0.85);
          transition: 0.3s;
          &:before {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            width: 50px;
            height: 50px;
            background-color: #707070;
            opacity: 0.54;
            transition: 0.6s;
            border-radius: 100%;
          }
          &:not(:last-child) {
            margin-right: -14px;
          }
          &:hover {
            transform: scale(1);
            &:before {
              opacity: 0;
            }
          }
          &.isActive {
            transform: scale(1);
            &:before {
              opacity: 0;
            }
          }
        }
      }
    }
  }
}
</style>
